import { makeStyles } from '@material-ui/core/styles';

// eslint-disable-next-line import/prefer-default-export
export const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiDialogContent-root': {
      padding: 0,
      background: theme.palette.grey5,
    },
    '& .MuiDialogTitle-root': {
      padding: 0,
    },
    '& .closeButtonDesktop': {
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
      '& .closeButton': {
        position: 'absolute',
        right: 0,
        '& svg': {
          height: '34px',
          width: '34px',
        },
        [theme.breakpoints.up('md')]: {
          position: 'absolute',
          right: 0,
        },
      },
    },
    '& .closeButtonWrapper': {
      boxShadow: '0',
      position: 'relative',
      width: '100%',
      zIndex: '11',

      [theme.breakpoints.down('md')]: {
        backgroundColor: theme.palette.blue1,
        boxShadow: '0 2px 10px 0 rgba(0,2,20,0.5)',
        padding: '0 16px',
        width: '100%',
      },

      [theme.breakpoints.up('md')]: {
        height: '0',
        zIndex: '40',

        '& .backArrow, & .backButton': {
          display: 'none',
        },
      },

      '& .closeButton': {
        cursor: 'pointer',
        display: 'flex',
        width: '71px',
        height: '64px',
        alignItems: 'center',
        position: 'absolute',
        right: 0,
        '& .backArrow, & .backButton': {
          color: 'white',
          textTransform: 'uppercase',
          letterSpacing: theme.typography.pxToRem(2),
        },

        '& .closeModal': {
          color: theme.palette.blue2,
          display: 'block',
          position: 'absolute',
          right: '25px;',
          top: '25px',
        },

        [theme.breakpoints.down('md')]: {
          position: 'initial',
        },

        [theme.breakpoints.down('xs')]: {
          cursor: 'pointer',
          color: theme.palette.white,
          fontFamily: 'Proxima',
          height: '64px',
          marginLeft: '-16px',
          marginRight: '-16px',
          textTransform: 'uppercase',
          width: '94px',

          '& .closeModal': {
            display: 'none',
          },

          '& .backButton': {
            fontSize: theme.typography.pxToRem(12),
            letterSpacing: theme.typography.pxToRem(2),
          },

          '&:hover': {
            textDecoration: 'none',
          },

          '& svg': {
            marginLeft: '6px',
          },
        },
      },
    },
    '& .stateRoom': {
      marginBottom: '15px',

      '& div h1': { fontSize: theme.typography.pxToRem(32) },
      '& p': {
        '& span:first-child': { fontWeight: 'bold' },
        '& span:before': { content: '" "' },
      },
      '&__card': {
        marginBottom: '24px',
      },
      '&__card:last-child': {
        marginBottom: 0,
      },
    },
    '& main': {
      backgroundColor: theme.palette.grey5,
      display: 'flex',
      margin: '0 auto',
      maxWidth: '1440px',
      minHeight: '92vh',
      verticalAlign: 'top',
      width: '100%',
      marginTop: 64,
      flexDirection: 'column',
      '& .guestAccountOn': {
        height: 'calc(100% - 140px) !important',

        [theme.breakpoints.up('md')]: {
          paddingTop: 24,
        },

        '& .sticky-outer-wrapper': {
          padding: 0,
        },
      },
      [theme.breakpoints.down('xs')]: {
        width: '100%',
        display: 'block',
      },
    },
    '& .section-container': {
      overflow: 'hidden',
      padding: 20,

      [theme.breakpoints.up('sm')]: {
        padding: '24px 50px',
      },

      [theme.breakpoints.up('lg')]: {
        padding: '24px 50px 0px 35px',
      },
      [theme.breakpoints.up('1441')]: {
        padding: '24px 0px 0px 35px',
      },
    },
    '& .guest-account-active': {
      marginTop: '0px !important',
    },
    '& aside.itinerary': {
      '& .sticky-outer-wrapper': {
        height: '100%',

        [theme.breakpoints.up('lg')]: {
          padding: ' 24px 0px',
        },
        [theme.breakpoints.up('xl')]: {
          padding: '36px 0px',
        },
        '& .sticky-inner-wrapper': {
          height: '100%',
          [theme.breakpoints.down('md')]: {
            height: '94%',
            transform: 'none !important',
          },
          '& > div': {
            height: '100% !important',
          },
        },
      },
      '& .sticky-outer-wrapper.active': {
        paddingTop: '69px',
        [theme.breakpoints.down('sm')]: {
          paddingTop: '0',
        },
      },
      display: 'inline-block',
      height: '100%',
      opacity: '1',
      left: 0,
      width: '100%',
      maxWidth: '380px',
      '& .MuiContainer-root': {
        animationName: '$itinerary',
        animationDuration: '.25s',
        animationTimingFunction: 'ease-in',
        height: '100%',
      },
      [theme.breakpoints.down('lg')]: {
        maxWidth: '350px',
      },
      [theme.breakpoints.only('md')]: {
        maxWidth: '380px',
      },
      [theme.breakpoints.up('md')]: {
        height: 'unset',
        position: 'relative',
      },
      [theme.breakpoints.down('md')]: {
        height: '100%',
        transform: 'translate(-100%, 0)',
        transition: 'opacity, transform .5s',
        position: 'absolute',
        zIndex: 1,
        '.panel-open&': {
          transform: 'translate(0, 0)',
        },
        marginTop: '0',
      },
      [theme.breakpoints.down('sm')]: {
        maxWidth: '100%',
      },
      [theme.breakpoints.up('lg')]: {
        marginTop: '0',
        paddingTop: '24px',
        marginLeft: 50,
      },
      [theme.breakpoints.up('xl')]: {
        paddingTop: '24px',
      },

      [theme.breakpoints.up('1441')]: {
        marginLeft: 0,
      },
    },
    '& section': {
      animationDuration: '.5s',
      animationFillMode: 'forwards',
      animationName: '$section',
      animationTimingFunction: 'ease-out',
      optcity: '0',
      transform: 'translate(0, 1%)',
      visibility: 'hidden',
      marginLeft: 'auto',
      width: '100%',
      padding: '68px 70px 0 60px',
      [theme.breakpoints.between('md', 'lg')]: {
        padding: '30px 70px 0 60px',
      },
      [theme.breakpoints.down('sm')]: {
        padding: '0 20px',
      },
      [theme.breakpoints.only('xs')]: {
        padding: '16px 0 0 0',
      },
    },
    '& .roomInfoDialog': {
      [theme.breakpoints.down('md')]: {
        display: 'block',
      },
    },
    '& .tempLink': {
      fontSize: '24px',
      paddingBottom: '30px',
      marginTop: '-30px',
    },
  },
  '@keyframes itinerary': {
    '0%': { opacity: '0', transform: 'translate(-100%, 0)' },
    '100%': { opacity: '1', transform: 'translate(0%, 0)' },
  },
  '@keyframes section': {
    '0%': {
      opacity: '0',
      transform: 'translate(0, 5%)',
      visibility: 'visible',
    },
    '100%': {
      opacity: '1',
      transform: 'translate(0%, 0)',
      visibility: 'visible',
    },
  },
  paymentDetails: {
    paddingTop: 32,
    [theme.breakpoints.up('sm')]: {
      paddingTop: 48,
    },
    '& p span:last-of-type': {
      fontFamily: theme.typography.proxima.semiBold,
    },
    '& h1': {
      textTransform: 'capitalize',
    },
  },
  paymentFlightDetails: {
    '& p span:nth-child(1)': {
      fontFamily: theme.typography.proxima.semiBold,
    },
  },
  blurBackground: {
    [theme.breakpoints.down('md')]: {
      '.panel-open &': {
        background: 'rgba(0, 0, 0, 0.5)',
        height: '100%',
        width: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
      },
    },
  },
  confirmationButton: {
    display: 'block',
    margin: '1rem auto 1rem auto',
  },
  getPaymentDueDate: {
    color: theme.palette.critical2,
    fontSize: theme.typography.pxToRem(16),
    [theme.breakpoints.up('lg')]: {
      fontSize: theme.typography.pxToRem(18),
    },
  },
  getCHstyling: {
    fontSize: theme.typography.pxToRem(16),
    [theme.breakpoints.up('lg')]: {
      fontSize: theme.typography.pxToRem(18),
    },
  },
  customTitle: {
    '& h1': {
      fontSize: `${theme.typography.pxToRem(24)}!important`,
      [theme.breakpoints.up('md')]: {
        fontSize: `${theme.typography.pxToRem(30)}!important`,
      },
      [theme.breakpoints.only('xl')]: {
        fontSize: `${theme.typography.pxToRem(32)}!important`,
      },
    },
  },
  notificationContainer: {
    padding: 20,
    paddingBottom: 0,

    [theme.breakpoints.up('sm')]: {
      padding: '24px 50px 0px',
    },

    [theme.breakpoints.up('lg')]: {
      padding: '24px 50px 0px',
    },

    [theme.breakpoints.up('1441')]: {
      padding: '24px 0px 0px',
    },

    '& img': {
      width: 56,
    },

    '& .apple-logo': {
      marginBottom: '-7px',
    },
  },

  linkNotification: {
    '& notification-banner::part(content)': {
      marginLeft: '-8px',
    },
  },

  additionalFlightButton: {
    borderRadius: '3px',
    border: `1px solid ${theme.palette.blue2}`,
    color: `${theme.palette.blue2}`,
    fontFamily: theme.typography.proxima.semiBold,
    '&:hover': {
      backgroundColor: 'rgba(0, 69, 195, .1)',
      border: `1px solid ${theme.palette.blue3}`,
      color: `${theme.palette.blue3}`,
    },
    '& span': {
      fontSize: '16px',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },

  flightsButtonsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },

  manageFlightButton: {
    fontFamily: theme.typography.proxima.semiBold,
    '&.MuiButton-containedPrimary': {
      marginLeft: '30px',
    },
    '& span': {
      fontSize: '16px',
    },
    [theme.breakpoints.down('sm')]: {
      '&.MuiButton-containedPrimary': {
        marginLeft: '0',
      },
      width: '100%',
      marginTop: '20px',
      marginLeft: '0',
    },
  },
}));
